import mainApi from '../mainApi'; // Use the centralized axios instance

// Named exports for specific API calls
export const getEvents = async () => {
  return mainApi.get('/events');
};

export const getMemberWorkoutPlans = async (memberId) => {
  return mainApi.get(`/assigned-workouts/${memberId}`);
};

export const logWorkoutSession = async (sessionData) => {
  // This endpoint doesn't seem to exist on the Node.js backend yet
  // return mainApi.post('/workout-sessions', sessionData);
  return Promise.reject(new Error('Endpoint not implemented'));
};

export const searchExercises = async (searchTerm, muscleGroups) => {
  let url = `/exercises/search?q=${searchTerm}`;
  if (muscleGroups) {
    url += `&muscle_groups=${muscleGroups}`;
  }
  return mainApi.get(url);
};

export const updateWorkoutProgress = async (progressData) => {
  // This endpoint doesn't seem to exist on the Node.js backend yet
  // return mainApi.put('/workout-progress', progressData);
  return Promise.reject(new Error('Endpoint not implemented'));
};

export const getMemberAnalytics = async (memberId) => {
    // This endpoint doesn't seem to exist on the Node.js backend yet
  // return mainApi.get(`/analytics/${memberId}`);
  return Promise.reject(new Error('Endpoint not implemented'));
};

export const addExercise = async (exerciseData) => {
    // The backend expects multipart/form-data for this, but this file doesn't support it.
    // This will need further refactoring to handle file uploads correctly.
  return mainApi.post('/exercises', exerciseData);
};

export const deleteExercise = async (exerciseId) => {
  return mainApi.delete(`/exercises/${exerciseId}`);
};

export const updateExercise = async (exerciseId, exerciseData) => {
  return mainApi.put(`/exercises/${exerciseId}`, exerciseData);
};

export const getMuscleGroups = async () => {
  return mainApi.get('/muscle-groups');
};

export const getWorkoutTemplate = async (templateId) => {
  return mainApi.get(`/workout-templates/${templateId}`);
};

export const getWorkoutTemplates = async () => {
  return mainApi.get('/workout-templates');
};

export const createWorkoutTemplate = async (templateData) => {
  return mainApi.post('/workout-templates', templateData);
};

export const updateWorkoutTemplate = async (templateId, templateData) => {
  return mainApi.put(`/workout-templates/${templateId}`, templateData);
};

export const deleteWorkoutTemplate = async (templateId) => {
  return mainApi.delete(`/workout-templates/${templateId}`);
};

export const createWorkoutPlan = async (planData) => {
  return mainApi.post('/assign-workout', planData);
};

export const getWorkoutPlan = async (planId) => {
    // This endpoint doesn't seem to exist on the Node.js backend yet
//   return mainApi.get(`/workout-plans/${planId}`);
    return Promise.reject(new Error('Endpoint not implemented'));
};

export const getAssignedWorkoutForMember = async (memberId) => {
  return mainApi.get(`/assigned-workouts/${memberId}`);
};